import { io } from 'socket.io-client';
const URL =
  import.meta.env.VITE_APP_API_URL || `https://${window.location.host}`;

export const socket = io(`${URL}/app`, {
  autoConnect: false,
  withCredentials: true,
});
